import { useState, useEffect } from "react";
import axios from "axios";

const useFetchMaintenance = (role) => {
  const [maintenanceData, setMaintenanceData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMaintenance = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const token = sessionStorage.getItem("token");
      if (!token) {
        throw new Error("Aucun token d'authentification trouvé");
      }

      const response = await axios.get(
        process.env.REACT_APP_DOMAIN_URL+"/api/processMaintenance",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // Le backend filtre déjà les données de maintenance selon le viewRole
      // Pas besoin de filtrage supplémentaire ici
      setMaintenanceData(response.data);
    } catch (error) {
      console.error("Erreur lors de la récupération des données de maintenance :", error);
      setError(error.toString());
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchMaintenance();
  }, [role]);

  return { maintenanceData, isLoading, error, refreshData: fetchMaintenance };
};

export default useFetchMaintenance;
